import { byClass, setStyle, removeElement, isMobile } from './utils'
import { getCubeImages } from './cubes'
import { getWearImages, getGiftsImages, getYourYearImages } from './milestone'
import { getWearItImages } from './wear'

const pageOneImageList = [
  require('../img/celebrating/background.jpg'),
  require('../img/celebrating/Yearbooks10.png'),
  require('../img/celebrating/Yearbooks15.png'),
  require('../img/celebrating/Yearbooks20.png'),
  require('../img/celebrating/Yearbooks25.png'),
  require('../img/celebrating/Yearbooks30.png'),
  require('../img/celebrating/Yearbooks35.png'),
  require('../img/celebrating/Yearbooks40.png'),
  require('../img/celebrating/Yearbooks45.png'),
  require('../img/celebrating/Yearbooks5.png'),
  require('../img/celebrating/Yearbooks50.png'),
  require('../img/celebrating/Yearbooks55.png'),
  require('../img/celebrating/Yearbooks7.png'),
  require('../img/celebrating/welcome.png'),
  require('../img/celebrating/jm.png'),
  require('../img/celebrating/johnson-matthey.png')
]
const pageOneImageObj = []
let progressTimer

/**
 * 加载第一页的图片资源
 */
function loadResource() {
  if (isMobile()) {
    const imageNodes = document.querySelectorAll('img')
    if (!imageNodes.length) {
      return
    }
    // Add init images.
    for (let i = 0; i < imageNodes.length; i++) {
      pageOneImageObj.push(imageNodes[i])
    }

    // Add your year images.
    getYourYearImages().forEach(imageUrl => {
      const imgObj = new Image()
      imgObj.src = imageUrl
      pageOneImageObj.push(imgObj)
    })

    // Add wear images.
    getWearImages().forEach(imageUrl => {
      const imgObj = new Image()
      imgObj.src = imageUrl
      pageOneImageObj.push(imgObj)
    })

    // Add wear it your way images
    getWearItImages().forEach(imageUrl => {
      const imgObj = new Image()
      imgObj.src = imageUrl
      pageOneImageObj.push(imgObj)
    })

    // Add cubes images.
    getCubeImages().forEach(imageUrl => {
      const imgObj = new Image()
      imgObj.src = imageUrl
      pageOneImageObj.push(imgObj)
    })

    // Add gifts images.
    getGiftsImages().forEach(imageUrl => {
      const imgObj = new Image()
      imgObj.src = imageUrl
      pageOneImageObj.push(imgObj)
    })

    imageNodes.length && (progressTimer = setInterval(checkProgress, 500))
  } else {
    for (const img of pageOneImageList) {
      const imgObj = new Image()
      imgObj.src = img
      pageOneImageObj.push(imgObj)
    }
    progressTimer = setInterval(checkProgress, 500)
  }
}

let lastCompleteCount = 0

/**
 * 检查第一页的图片加载好了没有
 */
function checkProgress () {
  let completeCount = 0
  for (const imgObj of pageOneImageObj) {
    if (imgObj.complete) {
      completeCount++
    }
  }
  completeCount = Math.max(lastCompleteCount, completeCount)
  lastCompleteCount = completeCount
  const totalCount = pageOneImageObj.length
  const percent = (completeCount / totalCount).toFixed(2)
  if (percent > 0.99) {
    clearInterval(progressTimer)
    document.body.classList.add('ready')
    setTimeout(() => {
      setStyle(document.body, { overflow: 'auto' })
      removeElement(byClass('loading-container'))
    }, 1000)
  }
  updateProgress(percent)
}

/**
 * 更新进度条
 */
function updateProgress (percent) {
  setStyle(byClass('progress-line'), {
    'flex-basis': `${percent * 100}%`
  })
}

loadResource()
